export enum RouteNames {
  HOME = "HOME",
  MOVEMENTS = "MOVEMENTS",
  ONLOAN = "ONLOAN",
  STOCK = "STOCK",
}
